export enum ClientType {
  BUSINESS = "BusinessClient",
  PRIVATE = "ParticularClient",
}
